"use client";

import React from "react";
import Link from "next/link";
import "@/scss/_404.scss";

export default function NotFound() {
  return (
    <div className="not-found-page-err">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="error-content-err">
              <h1 className="error-title-err">Oops! Page Not Found</h1>
              <p className="error-subtitle-err">
                The page you were looking for could not be found.
              </p>
              <Link href="/" className="btn-homepage-err">
                Go To Homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
